import { useCallback } from 'react';
import type { OpenT } from '@mentimeter/question-modules-types';
import {
  usePreviewResultsIterator,
  getOpenPreviewResultsIteration,
} from '@mentimeter/slides-preview-results';

const INITIAL_RESULTS: OpenT = {
  respondents: 0,
  type: 'open',
  results: [],
  isPlaceholderResults: true,
  timestamp: 0,
  votes: [],
  voter_count: 0,
};

interface UseOpenPreviewResultsProps {
  isEnabled: boolean;
}

export const useOpenPreviewResultsLegacy = ({
  isEnabled,
}: UseOpenPreviewResultsProps): OpenT => {
  const getNextResults = useCallback(
    (iteration: number, previous: OpenT | undefined) => {
      if (previous === undefined || previous.type === 'open') {
        return getOpenPreviewResultsIteration({
          iteration,
          previous,
          extras: null,
        });
      }
      return undefined;
    },
    [],
  );

  return (
    usePreviewResultsIterator(isEnabled, getNextResults) ?? INITIAL_RESULTS
  );
};
